module.exports = __webpack_public_path__ + "img/multi_manager.45103014.png";